import * as React from 'react';
import { GdsAggregationServiceGroup } from '../../../../../Checkout/types';
import Service from '../Service';
import { Meal as MealIcon } from '../../../../../Icons';
import { useServicePageProps } from '../../../../../CheckoutAdditionalService/components/hooks';
import { ServiceType } from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/types';
import ServiceCardDialog from '../../../../../Checkout/components/Checkout/OrderPaidServiceCards/components/ServiceCardDialog/ServiceCardDialog';
import ServicePage from '../../../../../Checkout/components/Checkout/ServicePage/ServicePage';
import { useTranslation } from 'react-i18next';
import { useCallback, useMemo } from 'react';

interface Props {
	services: GdsAggregationServiceGroup;
}

const Meal: React.FC<Props> = ({ services }) => {
	const { t } = useTranslation('FlightInfoCard'),
		{ t: aggregatedT } = useTranslation('ServiceAggregation');

	const servicePageProps = useServicePageProps();

	const servicesCount = useMemo(() => {
		return services.selectedServices.reduce((count, service) => count + service.count, 0);
	}, [services.selectedServices]);

	const open = useCallback(() => {
		servicePageProps.toggleModal(ServiceType.Meal);
	}, [servicePageProps.toggleModal]);

	return (
		<>
			<Service icon={MealIcon} selected={servicesCount > 0} onClick={open}>
				{servicesCount > 0 ? (
					<span>
						{t('Meal')}: {servicesCount} {aggregatedT('dish', { count: servicesCount })}
					</span>
				) : (
					<span>{t('Choose meal')}</span>
				)}
			</Service>

			<ServicePage>
				{childrenProps => (
					<ServiceCardDialog
						order={servicePageProps.order}
						openedModal={servicePageProps.openedModal}
						onClose={servicePageProps.toggleModal.bind(null, null)}
						passengers={servicePageProps.passengers}
						passengerLabels={servicePageProps.passengerLabels}
						{...childrenProps}
					/>
				)}
			</ServicePage>
		</>
	);
};

export default Meal;
